module.exports = __webpack_public_path__ + "img/sticker_turminha.67b1d426.png";